export default {"src":"/_next/static/media/prawns.3a9bb032.svg","height":683,"width":683,"blurWidth":0,"blurHeight":0};